import LogoBankWire from "app/components/Logos/LogoBankWire";
import ManageFundingLogoHeader from "app/screens/ManageFundingScreen/components/ManageFundingLogoHeader/ManageFundingLogoHeader";
import { ResponsiveScreenSizes } from "app/utils/const";
import Media from "react-media";

function BankWireFundingScreenHeader(props: {
  getTabs: Function;
  history: any;
}) {
  const { getTabs, history } = props;
  return (
    <>
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => (
          <div className="bank-wire-funding__header">
            <ManageFundingLogoHeader
              history={history}
              getTabs={getTabs()}
              logo={<LogoBankWire />}
            />
          </div>
        )}
      />
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => (
          <div className="bank-wire-funding__header">
            <div className="bank-wire-funding__header__title">
              <ManageFundingLogoHeader
                history={history}
                getTabs={getTabs()}
                logo={<LogoBankWire />}
              />
            </div>
          </div>
        )}
      />
    </>
  );
}
export default BankWireFundingScreenHeader;
